module.exports = __webpack_public_path__ + "static/media/yale.9f7ac162.png";